module.exports = __webpack_public_path__ + "media/promo/lum2021/images/hero-6d54a967dde97948e6810cc7da614e1e.jpg";